import React from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../contexts/NotificationContext";
import { BellIcon } from "@heroicons/react/24/outline";

const NotificationButton: React.FC = () => {
  const navigate = useNavigate();
  const { unreadCount, refresh } = useNotifications();

  const handleClick = () => {
    refresh(); // Refresh notifications when button is clicked
    navigate("/portal/notifications");
  };

  return (
    <div className="relative" title="Notifications">
      <button
        onClick={handleClick}
        aria-label="Notifications"
        className="p-2 rounded-full text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold transition-colors"
      >
        <BellIcon className="h-6 w-6" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-red-500 rounded-full">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default NotificationButton;
